import React, { useEffect, useState } from "react";
import { REACT_APP_API_URL } from "../config";
import "./NewMicrobiomeForm.full.css";
import axios from "axios";
import Select from "react-select";
import ThankYouModal from "../component/thankYouModal";
import toast, { Toaster } from "react-hot-toast";
import { useNavigate } from "react-router-dom";
import ErrorModal from "../component/ErrorModal";

// Shared styles for all React Select components
const customSelectStyles = {
  control: (base) => ({
    ...base,
    backgroundColor: "#dcf0ff",
    border: "none",
    borderRadius: "10px",
    padding: "0px 8px",
    minHeight: "44px",
    fontSize: "14px",
    boxShadow: "none",
    ":hover": {
      border: "none",
      boxShadow: "none",
    },
  }),
  valueContainer: (base) => ({
    ...base,
    padding: "0 0",
  }),
  indicatorsContainer: (base) => ({
    ...base,
    paddingRight: "8px",
  }),
  menu: (base) => ({
    ...base,
    backgroundColor: "#f5f8ff",
    borderRadius: "8px",
    border: "none",
    boxShadow: "0 4px 12px rgba(0,0,0,0.08)",
  }),
  option: (base, state) => ({
    ...base,
    borderRadius: "6px",
    padding: "10px 12px",
     fontSize: "14px",
    backgroundColor: state.isSelected
      ? "#19b5ff"
      : state.isFocused
        ? "#e0f4ff"
        : "white",
    cursor: "pointer",
    margin: "2px 4px",
  }),
};


export default function NewMicrobiomeForm() {
  // State for all fields

  const [selected, setSelected] = useState([]);
  const [showThankYou, setShowThankYou] = useState(false);
  const [isSubmitted, setIsSubmitted] = useState(false);
  const [kitTypes, setKitTypes] = useState([]);
  const[countries,setCountries]=useState([]);
  const [consent, setConsent] = useState(false);
  const [response, setResponse] = useState({});
  const navigate = useNavigate()
  const [showError, setShowError] = useState(false);
    const [isChild, setIsChild] = useState(false);
    const [stoolType, setStoolType] = useState([
    { label: "Type 1", description: "Separate hard lumps, like nuts (hard to pass)", value: "type_1", selected: false },
    { label: "Type 2", description: "Sausage-shaped but lumpy", value: "type_2", selected: false },
    { label: "Type 3", description: "Like a sausage but with cracks on the surface", value: "type_3", selected: false },
    { label: "Type 4", description: "Like a sausage or snake, smooth and soft", value: "type_4", selected: false },
    { label: "Type 5", description: "Soft blobs with clear-cut edges", value: "type_5", selected: false },
    { label: "Type 6", description: "Fluffy pieces with ragged edges, a mushy stool", value: "type_6", selected: false },
    { label: "Type 7", description: "Watery, no solid pieces. Entirely Liquid", value: "type_7", selected: false },
  ]);
  const [parentConsent, setParentConsent] = useState(false);
  const selectStoolType = (value) => {
    setStoolType((prev) =>
      prev.map((item) =>
        item.value === value
          ? { ...item, selected: true }
          : { ...item, selected: false },
      ),
    );
    setErrors((prev) => {
      if (!prev.stoolType) return prev;
      const { stoolType: _removed, ...rest } = prev;
      return rest;
    });
  };
const checkIsChild = (dob) => {
  const birthDate = new Date(dob);
  const today = new Date();

  // Create a date object for exactly 12 years ago
  const twelveYearsAgo = new Date();
  twelveYearsAgo.setFullYear(today.getFullYear() - 12);

  // If birthDate is greater than or equal to 12 years ago, they are 12 or younger
  const isChild = birthDate >= twelveYearsAgo;
  
  setIsChild(isChild);
};
  const fetchCountries = async () => {
    const baseUrl = REACT_APP_API_URL;
    if (!baseUrl) {
      console.error("REACT_APP_API_URL is not defined");
      return;
    }
    try {
      const response = await axios.get(`${baseUrl.replace(/\/$/, "")}/countries`);
      const raw = Array.isArray(response.data)
        ? response.data
        : response.data?.countries ?? response.data?.data ?? [];
      const countryList = raw
        .map((country) => {
          const name =
            typeof country === "string"
              ? country
              : country?.name?.common ?? country?.name ?? country?.label ?? "";
          const trimmed = typeof name === "string" ? name.trim() : "";
          return trimmed ? { label: trimmed, value: trimmed } : null;
        })
        .filter(Boolean)
        .sort((a, b) => a.label.localeCompare(b.label));
      setCountries(countryList);
    } catch (error) {
      console.error("Error fetching countries:", error);
    }
  };


const allowedKitTypes = [
  "GI Axis Microbiome",
  "GI Axis Microbial Screen",
  "GI Axis Advanced",
  "Oral Microbiome",
  "Food Sensitivity Map 130",
  "Food Sensitivity Map 270",
  "Food Sensitivity Map Advanced",
  "Food Sensitivity 95",
  "Food Sensitivity Vegan",
  "Food Sensitivity Junior",
  "CRP",
  "DNAMap Health and Nutrition",
  "DNAMap ADHD and Autism",
  "DNAMap Male Fertility",
  "DNAMap Female Fertility",
  "DNAMap Hair and Skin"
];


  const fetchKittypes = async () => {
    const response = await getkittypes();
    setKitTypes(response.data.kitTypes);
  };
const oldkittypes = [
  'Microbiome',
  'MicrobiomePlus',
  'MicrobiomeAdvanced',
  'Parasitology Test',
  'Food Sensitivtiy 100',
  'Food Sensitivtiy 210',
     "Food Sensitivity Advanced",
        "FoodSensitivityMap CRP",
]
  useEffect(() => {
    if (showThankYou) {
      setTimeout(() => {
        setShowThankYou(false);
      }, 5000);
    }
  }, [showThankYou]);

  useEffect(() => {
    fetchKittypes();
    fetchCountries();
  }, []);

  const configMaker = (method, url, params = null, body = {}) => {
    return {
      method,
      maxBodyLength: Infinity,
      url: `${REACT_APP_API_URL}/${url}`,
      headers: {
        "Content-Type": "application/json",
        // "Access-Token": accessTokens,
        // Authorization: `Bearer ${Tokens}`,
      },
      ...(params && { params }), // only adds if not null
      data: body,
    };
  };

  const getkittypes = async (image) => {
    const portalid = "67c17d743394a458c944eec2";
    try {
      const config = configMaker("get", "getallkittypes", { portalid }, {});
      const response = await axios.request(config);
      return response;
    } catch (error) {
      console.error("Error submitting ticket:", error);
      throw error;
    }
  };

  const submitKitForm = async (data) => {
    const portalId = "67c17d743394a458c944eec2";
    const config = configMaker("post", "submitkitform-gut-health-lab", {
      portalId,
    });
    config.data = data;
    const response = await axios.request(config);
    return response;
  };

  const [formData, setFormData] = useState({
    name: "",
    email: "",
    dob: "",
    weight: "",
    weightUnit: "KG",
    height: "",
    heightUnit: "FT & Inch",
    heightFeet: "",
    heightInches: "",
    gender: "Male",
    country: "",
    kitType: "",
    kitId: "",
    sampleDate: "",
    health: [],
    diet: "",
    eatingHabits: [],
    antibiotics: false,
  });

  const [errors, setErrors] = useState({
    health: "",
    diet: "",
    eatingHabits: "",
    antibiotics: "",
    consent: "",
    parentConsent: "",
  });

  const [healthConditions, setHealthConditions] = useState([
    {
      label: "Irritable Bowel Syndrome",
      icon: "/image53.svg",
      value: "irritable_bowel_syndrome",
      selected: false,
    },
    {
      label: "Inflammatory Bowel Disease",
      icon: "/image53.svg",
      value: "inflammatory_bowel_disease",
      selected: false,
    },
    {
      label: "Bloating / Gas issues",
      icon: "/image53.svg",
      value: "bloating_gas",
      selected: false,
    },
    {
      label: "I would like to lose weight",
      icon: "/image53.svg",
      value: "lose_weight",
      selected: false,
    },
    {
      label: "I would like to gain weight",
      icon: "/image53.svg",
      value: "gain_weight",
      selected: false,
    },
    {
      label: "Thyroid Conditions",
      icon: "/image53.svg",
      value: "thyroid",
      selected: false,
    },
    {
      label: "Heart / Cardiovascular problems",
      icon: "/image53.svg",
      value: "heart_problems",
      selected: false,
    },
    {
      label: "Skin Conditions",
      icon: "/image53.svg",
      value: "skin_conditions",
      selected: false,
    },
    {
      label: "Headaches / Migraines",
      icon: "/image53.svg",
      value: "migraines",
      selected: false,
    },
    {
      label: "Food Intolerances",
      icon: "/image53.svg",
      value: "food_intolerances",
      selected: false,
    },
    {
      label: "Arthritis",
      icon: "/image53.svg",
      value: "arthritis",
      selected: false,
    },
    {
      label: "Sleep Problems",
      icon: "/image53.svg",
      value: "sleep_problems",
      selected: false,
    },
    {
      label: "Diabetes",
      icon: "/image53.svg",
      value: "diabetes",
      selected: false,
    },
    {
      label: "No health conditions or concerns",
      icon: "",
      value: "No health conditions or concerns",
      selected: false,
    },
  ]);

  const [dietType, setDietType] = useState([
    {
      label: "Omnivore",
      icon: "/image53.svg",
      value: "omnivore",
      selected: false,
    },
    {
      label: "Vegetarian",
      icon: "/image53.svg",
      value: "vegetarian",
      selected: false,
    },
    { label: "Vegan", icon: "/image53.svg", value: "vegan", selected: false },
    {
      label: "Pescetarian",
      icon: "/image53.svg",
      value: "pescatarian",
      selected: false,
    },
  ]);
  const [eatingHabits, setEatingHabits] = useState([
    {
      label: "Intermittent Fasting",
      icon: "/image53.svg",
      value: "intermittent_fasting",
      selected: false,
    },
    {
      label: "High Protein",
      icon: "/image53.svg",
      value: "high_protein",
      selected: false,
    },
    {
      label: "Low Protein",
      icon: "/image53.svg",
      value: "low_protein",
      selected: false,
    },
    {
      label: "Ketogenic",
      icon: "/image53.svg",
      value: "ketogenic",
      selected: false,
    },
    {
      label: "High Carbohydrate",
      icon: "/image53.svg",
      value: "high_carb",
      selected: false,
    },
    {
      label: "Low Carbohydrates",
      icon: "/image53.svg",
      value: "low_carb",
      selected: false,
    },
    {
      label: "No specific diet",
      // icon: "/image53.svg",
      value: "No specific diet",
      selected: false,
    },
  ]);
  const [antibioticTaken, setAntibioticTaken] = useState("yes");
  const kitTypeOptions = [
    "Microbiome",
    "Oral Microbiome",
    "Candida",
    "DNA",
    "FoodSensitivityMap",
    "PRA",
  ];
  const initialFormState = {
    name: "",
    email: "",
    dob: "",
    weight: "",
    weightUnit: "KG",
    height: "",
    heightUnit: "FT & Inch",
    heightFeet: "",
    heightInches: "",
    gender: "Male",
    country: "",
    kitType: "",
    kitId: "",
    sampleDate: "",
    health: [],
    diet: "",
    eatingHabits: [],
    antibiotics: false,
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };
  const handleCheck = (name, value) => {
    setFormData((prev) => {
      const arr = prev[name];
      return arr.includes(value)
        ? { ...prev, [name]: arr.filter((v) => v !== value) }
        : { ...prev, [name]: [...arr, value] };
    });
    setErrors((prev) => ({ ...prev, [name]: "" }));
  };
  const handleRadio = (name, value) => {
    setFormData((prev) => ({ ...prev, [name]: value }));
    setErrors((prev) => ({ ...prev, [name]: "" }));
  };
  // const handleSubmit = (e) => {
  //   e.preventDefault();
  //   // const nextErrors = {
  //   //   health: form.health.length === 0 ? "Please select at least one option." : "",
  //   //   diet: form.diet ? "" : "Please select your diet type.",
  //   //   eatingHabits: form.eatingHabits.length === 0 ? "Please select at least one eating habit." : "",
  //   // };
  //   // setErrors(nextErrors);
  //   // const hasError = Object.values(nextErrors).some((m) => m);
  //   // if (hasError) return;
  //   // Log full form data to console
  //   // Using JSON stringify for easy readability
  //   // eslint-disable-next-line no-console
  //   let kitIdValue = form.kitId;
  //   if (form.kitType === "FoodSensitivityMap") {
  //     kitIdValue = `T4-${form.kitId}-YGM`;
  //   }
  //   const formToLog = { ...form, kitId: kitIdValue };
  //   console.log("Form data:", JSON.parse(JSON.stringify(formToLog)));
  //   alert("Form submitted!");
  // };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsSubmitted(true);

    // const nextErrors = {
    //   health:
    //     formData.health.length === 0
    //       ? "Please select at least one option."
    //       : "",
    //   diet: formData.diet ? "" : "Please select your diet type.",
    //   eatingHabits:
    //     formData.eatingHabits.length === 0
    //       ? "Please select at least one eating habit."
    //       : "",
    //   consent: !consent ? "You must consent to the terms and conditions to submit" : "",
    //   parentConsent: !parentConsent ? "You must consent to the terms and conditions to submit" : "",
    // };
    const nextErrors = {
  health: formData.health.length === 0 ? "Please select at least one option." : "",
  diet: formData.diet ? "" : "Please select your diet type.",
  eatingHabits: formData.eatingHabits.length === 0 ? "Please select at least one eating habit." : "",
  consent: !consent ? "You must consent to the terms and conditions to submit" : "",
  
  // Only adds parentConsent if isChild is truthy
  ...(isChild && { 
    parentConsent: !parentConsent ? "You must consent to the terms and conditions to submit" : "" 
  }),
};
    setErrors(nextErrors);
    
    if (Object.keys(nextErrors).some(key => nextErrors[key])) {
      setIsSubmitted(false);
      const firstKey = Object.keys(nextErrors).find(key => nextErrors[key]);
      toast.error(nextErrors[firstKey]);
      return;
    }
    
    let kitIdValue = formData.kitId;
    if (formData.kitType === "FoodSensitivityMap") {
      kitIdValue = `T4-${formData.kitId}-YGM`;
    }

    const payload = {
      name: formData.name,
      email: formData.email,
      dob: formData.dob,
      gender: formData.gender,
      height:
        formData.heightUnit === "FT & Inch"
          ? `${formData.heightFeet}' ${formData.heightInches || 0}"`
          : formData.height,
      heightUnit: formData.heightUnit,
      weightUnit: formData.weightUnit,
      weight: formData.weight,
      country: formData.country,
      sampleDate: formData.sampleDate,
      healthConditions: formData.health,
      dietType: formData.diet ? [formData.diet] : [],
      eatingHabits: formData.eatingHabits,
      antibioticTaken,
      kitId: kitIdValue,
      source:"GutHealthLab",
      stoolType: stoolType.filter((s) => s.selected).map((s) => s.value),
    };

    try {
      const response = await submitKitForm(payload);
      // console.log(payload); // ab yahan sahi value dikhegi
      
      if(response.data.status === 1){
        navigate("/registeryourkits/kitRegistered");
        // Reset form states only on success
        setHealthConditions([
        {
          label: "Irritable Bowel Syndrome",
          icon: "/image53.svg",
          value: "irritable_bowel_syndrome",
          selected: false,
        },
        {
          label: "Inflammatory Bowel Disease",
          icon: "/image53.svg",
          value: "inflammatory_bowel_disease",
          selected: false,
        },
        {
          label: "Bloating / Gas issues",
          icon: "/image53.svg",
          value: "bloating_gas",
          selected: false,
        },
        {
          label: "I would like to lose weight",
          icon: "/image53.svg",
          value: "lose_weight",
          selected: false,
        },
        {
          label: "I would like to gain weight",
          icon: "/image53.svg",
          value: "gain_weight",
          selected: false,
        },
        {
          label: "Thyroid Conditions",
          icon: "/image53.svg",
          value: "thyroid",
          selected: false,
        },
        {
          label: "Heart / Cardiovascular problems",
          icon: "/image53.svg",
          value: "heart_problems",
          selected: false,
        },
        {
          label: "Skin Conditions",
          icon: "/image53.svg",
          value: "skin_conditions",
          selected: false,
        },
        {
          label: "Headaches / Migraines",
          icon: "/image53.svg",
          value: "migraines",
          selected: false,
        },
        {
          label: "Food Intolerances",
          icon: "/image53.svg",
          value: "food_intolerances",
          selected: false,
        },
        {
          label: "Arthritis",
          icon: "/image53.svg",
          value: "arthritis",
          selected: false,
        },
        {
          label: "Sleep Problems",
          icon: "/image53.svg",
          value: "sleep_problems",
          selected: false,
        },
        {
          label: "Diabetes",
          icon: "/image53.svg",
          value: "diabetes",
          selected: false,
        },
      ]);
      setDietType([
        {
          label: "Omnivore",
          icon: "/image53.svg",
          value: "omnivore",
          selected: false,
        },
        {
          label: "Vegetarian",
          icon: "/image53.svg",
          value: "vegetarian",
          selected: false,
        },
        {
          label: "Vegan",
          icon: "/image53.svg",
          value: "vegan",
          selected: false,
        },
        {
          label: "Pescetarian",
          icon: "/image53.svg",
          value: "pescatarian",
          selected: false,
        },
      ]);
      setEatingHabits([
        {
          label: "Intermittent Fasting",
          icon: "/image53.svg",
          value: "intermittent_fasting",
          selected: false,
        },
        {
          label: "High Protein",
          icon: "/image53.svg",
          value: "high_protein",
          selected: false,
        },
        {
          label: "Low Protein",
          icon: "/image53.svg",
          value: "low_protein",
          selected: false,
        },
        {
          label: "Ketogenic",
          icon: "/image53.svg",
          value: "ketogenic",
          selected: false,
        },
        {
          label: "High Carbohydrate",
          icon: "/image53.svg",
          value: "high_carb",
          selected: false,
        },
        //Added new field
        {
          label: "Low Carbohydrates",
          icon: "/image53.svg",
          value: "low_carb",
          selected: false,
        },
        {
      label: "No specific diet",
      // icon: "/image53.svg",
      value: "No specific diet",
      selected: false,
    },
      ]);
      } else if (response.data.status === 0) {
        console.log("Showing error modal", response.data);
        setResponse(response.data);
        setShowError(true);
        setIsSubmitted(false);
      }
    } catch (err) {
      console.error("Form submit failed", err);
      setResponse({
        httpStatus: err.response?.status || 500,
        message: err.response?.data?.message || err.message || "An unexpected error occurred. Please try again later."
      });
      setShowError(true);
      setIsSubmitted(false);
    }
  };

  const PillToggle = ({ checked, onChange, children }) => (
    <button
      type="button"
      className={checked ? "pill-toggle selected" : "pill-toggle"}
      onClick={onChange}
      aria-pressed={checked}
    >
      <span className="pill-label">{children}</span>
      <span className={checked ? "switch on" : "switch"} />
    </button>
  );

  return (
    <div className="new-microbiome-form-wrapper">
      <Toaster position="top-center" reverseOrder={false} />
      <form className="new-microbiome-form" onSubmit={handleSubmit}>
        <div className="form-header-row">
          <h2>Register your kits</h2>
          <p className="main-heading">
            GutHealth<span>Lab</span>
          </p>
          {/* <img src="/logo512.png" alt="GutMapDx" className="logo-img" /> */}
        </div>
        <div className="form-grid">
          <div className="form-group name-group">
            <label>Name</label>
            <input
              name="name"
              value={formData.name}
              onChange={handleChange}
              required
            />
          </div>
          <div className="form-group email-group">
            <label>Email</label>
            <input
              name="email"
              value={formData.email}
              onChange={handleChange}
              type="email"
              required
            />
          </div>
          <div className="form-group dob-group">
            <label>Date of Birth</label>
            <input
              name="dob"
              type="date"
              value={formData.dob}
              onChange={(e)=>{handleChange(e); checkIsChild(e.target.value)}}
              required
            />
          </div>

          <div className="form-group weight-group">
            <label>Weight</label>
            <div className="row-flex">
              <Select
                value={{ label: formData.weightUnit, value: formData.weightUnit }}
                onChange={(selectedOption) =>
                  setFormData({
                    ...formData,
                    weightUnit: selectedOption.value
                  })
                }
                options={[
                  { label: "KG", value: "KG" },
                  { label: "LB", value: "LB" }
                ]}
                styles={customSelectStyles}
                isSearchable={false}
              />
              <input
                name="weight"
                type="number"
                value={formData.weight}
                onChange={handleChange}
                placeholder={formData.weightUnit}
                required
              />
            </div>
          </div>
          <div className="form-group height-group">
            <label>Height</label>
            <div className="input-select-wrapper">
              <Select
                value={{ label: formData.heightUnit, value: formData.heightUnit }}
                onChange={(selectedOption) =>
                  setFormData({
                    ...formData,
                    heightUnit: selectedOption.value,
                    height: "",
                    heightFeet: "",
                    heightInches: ""
                  })
                }
                options={[
                  { label: "FT & Inch", value: "FT & Inch" },
                  { label: "CM", value: "CM" }
                ]}
                styles={customSelectStyles}
                isSearchable={false}
              />
              {formData.heightUnit === "FT & Inch" ? (
                <div className="height-inputs-wrapper">
                  <input
                    name="heightFeet"
                    type="number"
                    value={formData.heightFeet}
                    onChange={(e) =>
                      setFormData({ ...formData, heightFeet: e.target.value })
                    }
                    placeholder="Feet"
                    required
                    className="second-row-input"
                  />
                  <input
                    name="heightInches"
                    type="number"
                    value={formData.heightInches}
                    onChange={(e) =>
                      setFormData({ ...formData, heightInches: e.target.value })
                    }
                    placeholder="Inches"
                    className="second-row-input"
                  />
                </div>
              ) : (
                <input
                  name="height"
                  type="number"
                  value={formData.height}
                  onChange={(e) =>
                    setFormData({ ...formData, height: e.target.value })
                  }
                  placeholder="CM"
                  required
                  className="second-row-input"
                />
              )}
            </div>
          </div>
          <div className="form-group gender-group">
            <label>Gender at Birth</label>
            <Select
              value={{ label: formData.gender, value: formData.gender }}
              onChange={(selectedOption) =>
                setFormData({
                  ...formData,
                  gender: selectedOption.value
                })
              }
              options={[
                { label: "Male", value: "Male" },
                { label: "Female", value: "Female" },
                { label: "Other", value: "Other" }
              ]}
              styles={customSelectStyles}
              isSearchable={false}
            />
          </div>
          <div className="form-group country-group">
            <label>Country of Residence</label>
            <Select
              value={countries.find((country) => country.value === formData.country) || null}
              onChange={(selectedOption) =>
                setFormData({
                  ...formData,
                  country: selectedOption ? selectedOption.value : ""
                })
              }
              options={countries}
              placeholder="Select Country"
              isSearchable
              required
              styles={customSelectStyles}
            />
          </div>
          {/* <div className="form-group kittype-group">
            <label>Kit Type</label>
            <Select
              value={
                formData.kitType
                  ? { label: formData.kitType, value: formData.kitType }
                  : null
              }
              onChange={(selectedOption) =>
                setFormData({
                  ...formData,
                  kitType: selectedOption ? selectedOption.value : ""
                })
              }
              options={allowedKitTypes
                .filter(type => !oldkittypes.includes(type))
                .map((type) => ({ label: type, value: type }))}
              placeholder="Please Select KIT Type"
              isSearchable
              required
              styles={customSelectStyles}
            />
          </div> */}
          <div className="form-group kitid-group">
            <label>Kit ID</label>
            {formData.kitType === "FoodSensitivityMap" ? (
              <div className="kitid-composite">
                <span className="segment prefix">T4-</span>
                <input
                  name="kitId"
                  type="number"
                  value={formData.kitId}
                  onChange={handleChange}
                  placeholder="Kit-Code"
                  required
                  inputMode="numeric"
                />
                <span className="segment suffix">-YGM</span>
              </div>
            ) : (
              <input
                name="kitId"
                value={formData.kitId}
                onChange={handleChange}
                required
              />
            )}
          </div>
          <div className="form-group sampledate-group">
            <label>Sample Date</label>
            <input
              name="sampleDate"
              type="date"
              value={formData.sampleDate}
              onChange={handleChange}
              required
            />
          </div>
        </div>
        {formData.kitType !== "DNAMap Genetic Test" && (
          <>
            <div className="section">
              <label>
                Do you have any of the below health conditions or concerns?
              </label>
              <div className="checkbox-grid">
                {healthConditions.map((opt) => (
                  <PillToggle
                    key={opt.value}
                    checked={formData.health.includes(opt.value)}
                    onChange={() => handleCheck("health", opt.value)}
                  >
                    {opt.label}
                  </PillToggle>
                ))}
              </div>
              {isSubmitted && errors.health && (
                <div style={{ color: "#c62828", fontSize: "12px", marginTop: "6px" }}>{errors.health}</div>
              )}
            </div>

    {/* Stool Type */}
              <div
                className="section"
                style={{
                  borderBottom:
                    isSubmitted && errors?.stoolType
                      ? "2px solid #c62828"
                      : undefined,
                  paddingBottom:
                    isSubmitted && errors?.stoolType ? "12px" : undefined,
                  marginBottom:
                    isSubmitted && errors?.stoolType ? "4px" : undefined,
                }}
              >
                <label className="">
                  Which of the below best describes your typical stool? If
                  variable, pick the most common
                </label>
                <div className="checkbox-grid">
                  {stoolType.map((condition, index) => (
                    <label
                      key={index}
                      className="pill-toggle"
                      style={{
                        display:"flex",
                        height:"fit-content",
                        gap:"20px",
                        backgroundColor: condition.selected ? "#8dccff" :"#ddf0ff",
                        color: condition.selected ? "white" : "black",
                      }}
                    >
                      <img
                        src={`/stooltypes/type${index + 1}.png`}
                        alt={condition.label}
                        style={{
                          width: "40px",
                          height: "40px",
                          objectFit: "contain",
                        }}
                      />
                      <div style={{ display: "flex", flexDirection: "column", gap: "2px" }}>
                        <span style={{ fontWeight: "600" }}>{condition.label}</span>
                        <span style={{ fontSize: "11px", opacity: 0.85 }}>{condition.description}</span>
                      </div>
                      <input
                        type="checkbox"
                        className="checkinput2"
                        style={{display:"none"}}
                        name="stoolType"
                        value={condition.value}
                        checked={condition.selected}
                        onChange={() => selectStoolType(condition.value)}
                      />
                      <span className="checkmark"></span>
                    </label>
                  ))}
                </div>
              </div>

            <div className="section">
              <label>What best describes your diet type?</label>
              <div className="button-group">
                {dietType.map((opt) => (
                  <PillToggle
                    key={opt.value}
                    checked={formData.diet === opt.value}
                    onChange={() => handleRadio("diet", opt.value)}
                  >
                    {opt.label}
                  </PillToggle>
                ))}
              </div>
              {isSubmitted && errors.diet && (
                <div style={{ color: "#c62828", fontSize: "12px", marginTop: "6px" }}>{errors.diet}</div>
              )}
            </div>
            <div className="section">
              <label>Do you follow any of these eating habits?</label>
              <div className="button-group">
                {eatingHabits.map((opt) => (
                  <PillToggle
                    key={opt.value}
                    checked={formData.eatingHabits.includes(opt.value)}
                    onChange={() => handleCheck("eatingHabits", opt.value)}
                  >
                    {opt.label}
                  </PillToggle>
                ))}
              </div>
              {isSubmitted && errors.eatingHabits && (
                <div style={{ color: "#c62828", fontSize: "12px", marginTop: "6px" }}>{errors.eatingHabits}</div>
              )}
            </div>
            <div className="section">
              <label>Have you taken antibiotics in the last 12 months?</label>
              <div className="antibiotic-row">
                <div className="antibiotic-toggle">
                  <button
                    type="button"
                    className={
                      formData.antibiotics === true
                        ? "antibiotic-pill selected"
                        : "antibiotic-pill"
                    }
                    onClick={() => handleRadio("antibiotics", true)}
                    aria-pressed={formData.antibiotics === true}
                  >
                    <span>✅</span>
                    <span>Yes</span>
                  </button>
                  <button
                    type="button"
                    className={
                      formData.antibiotics === false
                        ? "antibiotic-pill selected no"
                        : "antibiotic-pill no"
                    }
                    onClick={() => handleRadio("antibiotics", false)}
                    aria-pressed={formData.antibiotics === false}
                  >
                    <span>❌</span>
                    <span>No</span>
                  </button>
                </div>
              </div>
            </div>
            <div className="section full-width">
              <div className="consent-checkbox">
                <label className="custom-checkbox">
                  <input
                    type="checkbox"
                    className="checkinput2"
                    checked={consent}
                    onChange={(e) => setConsent(e.target.checked)}
                  />
                  <span className="checkmark"></span>
                  <span className="consent-label-text">
                    I consent to the terms and conditions and understand that
                    anonymous test data is used to improve our gut health
                    solutions.
                  </span>
                </label>
              </div>
              {isChild &&  <div className="consent-checkbox">
                  <label className="custom-checkbox">
                    <input
                      type="checkbox"
                      className="checkinput2"
                      checked={parentConsent}
                      onChange={(e) => setParentConsent(e.target.checked)}
                    />
                    <span className="checkmark"></span>
                    <div className="" style={{display:"flex",flexDirection:"column"}}>
                    <span className="">Parental/Guardian Consent</span>
                    <span className="consent-label-text">
                      By ticking this box, I consent to the analysis of my child’s sample. I understand that all dietary changes and prebiotic use must be supervised by a qualified health practitioner.
                    </span>
                    </div>
                  </label>
                </div>}
              {isSubmitted && errors.consent && (
                <div style={{ color: "#c62828", fontSize: "12px", marginTop: "6px" }}>{errors.consent}</div>
              )}
              {isSubmitted && errors.parentConsent && (
                <div style={{ color: "#c62828", fontSize: "12px", marginTop: "6px" }}>{errors.parentConsent}</div>
              )}
              <div style={{ marginTop: '20px' }}>
                <button type="submit" className="inline-submit" style={{ width: '100%' }}>
                  Submit
                </button>
              </div>
            </div>
          </>
        )}
        {formData.kitType === "DNAMap Genetic Test" && (
          <div
            className="submit-section full-width "
            style={{ marginTop: "60px", width: "auto" }}
          >
            <button
              type="submit"
              className="submit-btn inline-submit"
              style={{ width: "100%" }}
            >
              Submit
            </button>
          </div>
        )}
      </form>
      <ErrorModal
                isOpen={showError}
                onClose={() => setShowError(false)}
                title="Failed to Submit"
                errorCode={response?.httpStatus}
                // message={
                //   response?.message ||
                //   "There was an issue registering your Kit. Please try again or contact support."
                // }
                message={
                  "There was an issue registering your Kit. Please try again or contact support."
                }
              />
    </div>
  );
}
